import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
// HOCS
import withLoading from 'hocs/WithLoading';
// Hooks
import useResponsive from 'hooks/useResponsive';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Core componentes
import { ContainedButton } from 'components/core/Button';
// Models
import { publicName } from 'models/cpm/carpark';
// Custom
import { listRowSpecsShape, cpmCarparkDataShape } from 'constants/PropTypesShapes';
import { bookPath } from 'cpmBook/navigation';
import { addressDescCC } from 'utils/Tools';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';

const CarparkRow = React.forwardRef(({ carpark, rowSpecs, handleStartLoading }, ref) => {
  const { id: carparkId } = carpark;
  // Specific permissions
  const {
    pBooking: { bookings },
  } = permissions;

  const isMobile = useResponsive();

  return (
    <TableRow ref={ref} element={carpark} rowSpecs={rowSpecs}>
      {/* ----- Name ----- */}
      <TableCell className={classnames({ 'table-first-details': rowSpecs.withDetails })}>
        <TruncatedTooltipText>{publicName(carpark)}</TruncatedTooltipText>
      </TableCell>
      {/* ----- Address ----- */}
      <TableCell className="hidden-md-down">
        <TruncatedTooltipText>{addressDescCC(carpark.address)}</TruncatedTooltipText>
      </TableCell>
      <TableCell className="d-flex justify-content-end">
        <OnlyWith
          key="bPermission"
          permissions={{
            needed: bookings,
            permissionsOrContext: carpark.permissions,
          }}
        >
          <ContainedButton
            label={<LocalizedMessage id={isMobile ? 'button.book' : 'button.bookOnCarpark'} />}
            onClick={handleStartLoading}
            path={bookPath(carparkId)}
          />
        </OnlyWith>
      </TableCell>
    </TableRow>
  );
});

CarparkRow.displayName = 'CarparkRow';

CarparkRow.propTypes = {
  carpark: cpmCarparkDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

module.exports = withLoading(CarparkRow);



// WEBPACK FOOTER //
// ./routes/book/assets/CarparkRow.js